<template>
  <div class="betgameEditIcon" id="betgameEditIcon">

    <NavigationBar>
      <template v-slot:left>
        <img class="back" src="../assets/icons/ic_16_back.svg" v-on:click="goBack" data-testid="nav-back">
      </template>
      <template v-slot:center>
        {{ $t('betgame_settings.betgame_logo') }}
      </template>
      <template v-slot:right>
        <div style="display: flex;" v-on:click="openHelp" data-testid="points-help-open"><HintIcon class="navigation_icon"></HintIcon></div>
      </template>
    </NavigationBar>

    <div class="notification">
      <div class="notification-icon">
        <img v-if="!isValidIcon(this.$store.state.betgame.icon)" src="../assets/icons/logo_placeholder.svg">
        <img v-else v-bind:src="buildIconPath(this.$store.state.betgame.icon, 300)">
      </div>
      <div v-if="this.$store.state.betgame.icon" style="font-size: 10px; color: lightgray; margin-top: -20px; margin-bottom: 20px;">{{ this.$store.state.betgame.icon }}</div>
      <h1 data-testid="betgame-icon-heading">{{ $t('betgame_settings.betgame_image_upload_title') }}</h1>
      <p>{{ $t('betgame_settings.betgame_image_upload_text_1') }}</p>
      <input id="imageFileInput" type="file" multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
             accept="image/*" class="input-file" hidden data-testid="betgame-icon-file">
      <button v-if="!isValidIcon(this.$store.state.betgame.icon)" v-on:click="uploadButtonClicked" data-testid="betgame-icon-save">
        <img class="button-icon button-icon--left" src="../assets/icons/ic_12_plus_white.svg">{{ $t('betgame_settings.betgame_image_upload') }}
      </button>
      <button v-if="isValidIcon(this.$store.state.betgame.icon)" v-on:click="uploadButtonClicked" data-testid="betgame-icon-save">
        <img class="button-icon button-icon--left" src="../assets/icons/ic_12_switch.svg">{{ $t('betgame_settings.betgame_image_edit') }}
      </button>
      <button v-if="isValidIcon(this.$store.state.betgame.icon)" v-on:click="deleteButtonClicked" class="button-danger" data-testid="betgame-icon-delete"><img class="button-icon button-icon--left" src="../assets/icons/ic_12_delete.svg">{{ $t('betgame_settings.betgame_image_delete') }}</button>
    </div>
    
    <!--
    <div class="input-container">
      <div>
        <div class="input-header">
          {{ $t('betgame_settings.betgame_image_upload_title') }}
        </div>
        <div class="input-infotext">
          {{ $t('betgame_settings.betgame_image_upload_text_1') }}
        </div>
      </div>
      
      <div style="margin-bottom: 20px;">
        <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
          <div class="dropbox">
            <input type="file" multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                   accept="image/*" class="input-file">
            <p v-if="isInitial">
              {{ $t('betgame_settings.betgame_image_select_file_text') }}
            </p>
            <p v-if="isSaving">
              {{ $t('betgame_settings.betgame_image_saving') }}
            </p>
          </div>
        </form>
      </div>
    </div>

    <div v-if="isValidIcon(this.$store.state.betgame.icon)" class="input-container">
      <div class="input-header">
        {{ $t('betgame_settings.betgame_image_delete') }}
      </div>
      <div style="margin-top: 0px; margin-bottom: 20px;">
        <img style="max-width: 64px; max-height: 64px;" v-bind:src="buildIconPath(this.$store.state.betgame.icon, 300)">
        <button v-on:click="deleteButtonClicked">{{ $t('button_delete_text') }}</button>
      </div>
    </div> 
    -->
    
    <modal class="modal" name="edit-points-help" id="edit-points-help" data-testid="points-help" :scrollable="true" width="100%" height="auto">
      <div class="modal-header">
        <div class="modal-header-left"></div>
        <div class="modal-header-center">{{ $t('betgame_settings.betgame_hint') }}</div>
        <div class="modal-header-right">
          <button
            type="button"
            class="btn-close"
            @click="$modal.hide('edit-points-help')"
            aria-label="Close modal"
            data-testid="points-help-close">
          </button>
        </div>
      </div>
      <div class="modal-body">
        <p>
          {{ $t('betgame_settings.betgame_image_upload_text_2') }}   
        </p>
      </div>
    </modal>
    
  </div>
</template>

<script>

import NavigationBar from './../components/NavigationBar'
import { TOAST_DURATION } from '@/main'
import HintIcon from './../components/icons/HintIcon'
import { orientImageFile } from '@/utils/orientImage'

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

export default {
  name: 'BetgameEditIcon',
  components: { NavigationBar, HintIcon },
  data () {
    return {
      currentStatus: null,
      uploadFieldName: 'icon'
    }
  },
  created () {

  },
  mounted () {
    this.reset();
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },  
  methods: {
    openHelp() {
      this.$modal.show('edit-points-help');
    },
    updateBetgame (data) {
      this.$store.dispatch('patchBetgame', data)
      .then(() => {
        this.$toast.open({ message: this.$i18n.t('save_changes_success'),
          position: 'top',
          duration: TOAST_DURATION,
          type: 'success'
        })
        this.$store.dispatch('updateBetgameIcon', null)
        .then(() => {
          this.$router.push('/betgameedit')
        })
      })
      .catch(function (error) {
        this.$toast.open({ message: this.$i18n.t('save_changes_error'),
          position: 'top',
          duration: TOAST_DURATION,
          type: 'error'
        })
      })
      .finally(function () {
      })
    },
    uploadButtonClicked() {
      document.getElementById('imageFileInput').click()
    },
    deleteButtonClicked() {
      this.updateBetgame({ icon: null })
    },
    reset() {
      this.currentStatus = STATUS_INITIAL;
    },
    save(file) {
      this.currentStatus = STATUS_SAVING
      const that = this
      this.$store.dispatch('uploadBetgameIcon', file)
      .then(() => {
        that.currentStatus = STATUS_SUCCESS
        //that.$router.push('/betgameedit')
      })
      .catch(err => {
        that.currentStatus = STATUS_FAILED
        this.$toast.open({ message: this.$i18n.t('save_changes_error'),
          position: 'top',
          duration: TOAST_DURATION,
          type: 'error'
        })
      })
    },
    async filesChange(fieldName, fileList) {
      if (!fileList.length) return;
      let file = fileList[0]
      let fileSizeinMB = file.size/1024/1024
      if(fileSizeinMB < 10) {
        try {
          file = await orientImageFile(file)
        } catch (e) {
          this.$toast.open({ message: this.$i18n.t('save_changes_error'),
            position: 'top',
            duration: TOAST_DURATION,
            type: 'error'
          })
        }
        this.save(file);
      } else {
        this.currentStatus = STATUS_FAILED
        this.$toast.open({ message: this.$i18n.t('save_changes_error'),
          position: 'top',
          duration: TOAST_DURATION,
          type: 'error'
        })
      }
    },    
    goBack () {
      this.$router.push('/betgameedit')
    }
  }
}
</script>

<style lang="scss" scoped>
.input-container {
  margin: 16px auto 0;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.notification {
  &-icon {
    width: 80px;
    height: 80px;
    background: rgba(var(--color-text-rgb), .08);
    margin: 22px auto;
    border-radius: 8px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      image-orientation: from-image;
    }
  }

  p {
    margin-bottom: 26px;
  }

  button {
    margin-top: 16px;
  }
}
</style>
